module.exports = __webpack_public_path__ + "img/AF987A_2F2416_523F27_6B5331-256px.937ea513.png";